import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { MeModel } from '../models/me.model';

export class MeApiService extends ApiService {
  static endpoint = 'auth/me';

  /**
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async get(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUrl(), {
      ...config,
      dataModel: MeModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
